const keyWbhpmClearUrl = () => {
	let shouldClearUrls = false;

	if (
		document.body.classList.contains('page-template-template-management-portal')
	) {
		// in the management portal we only get this query param in response to a login event
		// it also occasionally gets overloaded in order to deliver an error or success message
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		shouldClearUrls = urlParams.has('key_wbhp_m_account_session_otp') || false;
	}

	if (shouldClearUrls) {
		window.history.pushState({}, document.title, window.location.pathname);
	}
};

const keyWbhpmCurrencyPad = (amount = '') => {
	const splitVal = amount.toString().split('.', 2);
	const pounds = splitVal[0];
	const pence = splitVal[1] ?? '00';

	return `${pounds}.${pence.padEnd(2, '0')}`;
};

const updateExtraTotal = () => {
	const extras = document.querySelector('.wbhp-m-form--extras-add');
	if (!extras) { return; }
	const extraTotal = extras.querySelector('.extras-cta-and-price > p span');
	const extraItems = extras.querySelectorAll('select');
	let initialTotal = 0;
	(extraItems || []).forEach((extraItem) => {
		const parent = extraItem.parentNode;
		if (parent) {
			const price = parent.getAttribute('data-price') || 1;
			const totalPrice = extraItem.value * price;
			initialTotal += totalPrice;
		}
	});

	extraTotal.innerHTML = `£${keyWbhpmCurrencyPad(initialTotal)}`;

	const addExtrasCta = extras.querySelector('.extras-cta-and-price .cta');
	if (addExtrasCta && initialTotal <= 0) {
		addExtrasCta.disabled = true;
	} else if (addExtrasCta) {
		addExtrasCta.disabled = false;
	}
};

const keyWbhpmExtras = () => {
	const extras = document.querySelector('.wbhp-m-form--extras-add');

	if (!extras) { return; }

	const extraItems = extras.querySelectorAll('select');
	(extraItems || []).forEach((extraItem) => {
		const parent = extraItem.parentNode;
		if (parent) {
			const price = parent.getAttribute('data-price') || 1;
			const totalPrice = extraItem.value * price;
			const priceDisplay = parent.querySelector('.extra-input__select-and-cost__cost');

			if (priceDisplay) {
				priceDisplay.innerHTML = `£${keyWbhpmCurrencyPad(totalPrice)}`;
				priceDisplay.setAttribute('data-value', totalPrice);
			}
		}

		extraItem.addEventListener('change', () => {
			if (parent) {
				const price = parent.getAttribute('data-price') || 1;
				const totalPrice = extraItem.value * price;
				const priceDisplay = parent.querySelector('.extra-input__select-and-cost__cost');
				if (priceDisplay) {
					priceDisplay.innerHTML = `£${keyWbhpmCurrencyPad(totalPrice)}`;
					priceDisplay.setAttribute('data-value', totalPrice);
				}

				updateExtraTotal();
			}
		});
	});

	updateExtraTotal();
};

export const init = () => {
	// clean up URLs on the portal pages
	keyWbhpmClearUrl();
	// do maths on the extra pages
	keyWbhpmExtras();
};

export default init;
